// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page__create-stack{padding:0 20px;min-height:100vh}.page__create-stack .button-container{margin-top:24px;justify-content:left}.page__create-stack .container-stack{max-width:910px;padding:0}", ""]);
// Exports
module.exports = exports;
